import React from 'react';
import { useNavigate } from 'react-router-dom';

interface StatusCardProps {
  card: {
    title: string;
    value: string;
    change: string;
    changeType: 'increase' | 'decrease' | 'neutral';
    icon: React.ComponentType<any>;
    color: string;
    subtitle?: string;
    navigateTo?: string; // New prop for navigation
  };
}

const StatusCard: React.FC<StatusCardProps> = ({ card }) => {
  const navigate = useNavigate();

  const getChangeColor = (changeType: string) => {
    if (changeType === 'increase') return 'text-green-600';
    if (changeType === 'decrease') return 'text-red-600';
    return 'text-gray-600';
  };

  const Icon = card.icon;

  const handleClick = () => {
    if (card.navigateTo) {
      navigate(card.navigateTo);
    }
  };
  
  return (
    <div 
      className={`min-h-[120px] rounded-lg border border-[#E6EAF1] bg-white px-4 py-3 transition-shadow hover:shadow-sm ${
        card.navigateTo ? 'cursor-pointer' : ''
      }`}
      onClick={handleClick}
    >
      <h3 className="mb-2 text-[16px] font-medium leading-tight text-[#5F6880]">{card.title}</h3>
      
      {card.subtitle && (
        <p className="text-xs text-gray-500 mb-3">
          {card.subtitle}
        </p>
      )}
      
      {/* Value and Icon row */}
      <div className="mb-2 flex items-center justify-between">
        <p className="text-[37px] font-semibold leading-none tracking-[-0.02em] text-[#1A2340]">
          {card.value}
        </p>
        <Icon size={40} />
      </div>
      
      {/* Change percentage */}
      <p className={`text-sm font-medium ${getChangeColor(card.changeType)}`}>
        {card.changeType === 'increase' ? '↑' : card.changeType === 'decrease' ? '↓' : '•'} {card.change.replace('+', '').replace('-', '')}
      </p>
    </div>
  );
};

export default StatusCard;